import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "delete-timer"
};
const _hoisted_2 = {
  class: "btn-group"
};
import { storeToRefs } from 'pinia';
import { ElMessage } from 'element-plus';
import { mctRequest } from '@/api/axios';
import { useSetTimerStore } from '@/store/setTimer';
export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteTimerRule',
  setup(__props) {
    const useSetTimer = useSetTimerStore();
    const {
      deleteTimerRoleDialogVisible,
      currRuleId,
      refreshTimerRule,
      refreshSetTimer
    } = storeToRefs(useSetTimer);
    const handleDelete = async () => {
      const config = {
        url: `/timerSettingRule/delete?ruleId=${currRuleId.value}`,
        method: 'post'
      };
      await mctRequest.request(config);
      ElMessage({
        type: 'success',
        message: 'Delete completed'
      });
      deleteTimerRoleDialogVisible.value = false;
      refreshTimerRule.value++;
      refreshSetTimer.value++;
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "delete-notification"
      }, [_createTextVNode(" Are you sure to "), _createElementVNode("span", {
        class: "mct-red"
      }, "delete"), _createTextVNode(" this timer rule? ")], -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        plain: "",
        onClick: _cache[0] || (_cache[0] = $event => deleteTimerRoleDialogVisible.value = false)
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode(" Cancel ")])),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "danger",
        onClick: handleDelete
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("Confirm")])),
        _: 1
      })])]);
    };
  }
});